import { Tooltip } from '@mui/material';
import React from 'react';
const TOOLTIP_CONTENT = {
    CGM: {
        intro: "Activating Data Sharing turns on the data flow into SweetSpot and enables CPT code 95251 — interpretation and management of continuous glucose monitoring data, covering the provider's review and clinical decision-making based on CGM readings.",
    },
    CCM: {
        intro: 'Chronic Care Management enables CPT codes:',
        bullets: [
            '• 99490 — First 20 min of clinical staff time per calendar month',
            '• 99439 — Each additional 20 min of clinical staff time/month',
            '• 99487 — Complex CCM, first 60 min of clinical staff time',
            '• 99489 — Each additional 30 min of complex CCM services',
        ],
    },
    RPM: {
        intro: 'Remote Patient Monitoring enables CPT codes:',
        bullets: [
            '• 99445 — Collection of at least 2 days of data in a 30 day billing period',
            '• 99454 — Collection of at least 16 days of data in a 30 day billing period',
            '• 99470 — First 10-19 minutes of treatment management services/month',
            '• 99457 — First 20 min of treatment management services/month',
            '• 99458 — Each additional 20 min of treatment management',
        ],
    },
};
export const ConsentHelpIcon = (props) => {
    const { program } = props;
    const content = TOOLTIP_CONTENT[program];
    if (!content)
        return null;
    const tooltipTitle = (React.createElement("div", null,
        React.createElement("div", null, content.intro),
        content.bullets && (React.createElement("ul", { style: { margin: '8px 0 0', paddingLeft: '18px' } }, content.bullets.map((item, i) => (React.createElement("li", { key: i, style: { marginBottom: '4px' } }, item)))))));
    return (React.createElement(Tooltip, { title: tooltipTitle, arrow: true, componentsProps: {
            tooltip: {
                sx: {
                    backgroundColor: '#1f1f1f',
                    color: '#fff',
                    fontSize: '14px',
                    lineHeight: 1.5,
                    padding: '12px 16px',
                    borderRadius: '12px',
                    maxWidth: 300,
                },
            },
            arrow: {
                sx: { color: '#1f1f1f' },
            },
        } },
        React.createElement("div", { style: {
                backgroundColor: '#E6E6E6',
                height: '18px',
                width: '18px',
                borderRadius: '9px',
                color: '#737373',
                marginLeft: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
                marginTop: 'auto',
                marginBottom: 'auto'
            } }, "?")));
};
